import * as React from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { IconButtonGroup, IconButtonGroupProps } from '../../common'
import { ViewType } from '@/stores/useViewAsToggle/useViewAsToggle'

type ViewAsToggleProps = {
    activeView: ViewType
    onViewChange: (view: ViewType) => void
    icons?: {
        chart: string
        table: string
    }
}

export const ViewAsToggle: React.FC<ViewAsToggleProps> = ({
    activeView,
    onViewChange,
    icons,
}) => {
    const { t } = useTranslation('translations')

    const buttons: IconButtonGroupProps['buttons'] = [
        {
            id: 'chart',
            name: icons?.chart ?? 'stacked_line_chart',
            size: 'medium',
        },
        { id: 'table', name: icons?.table ?? 'table', size: 'medium' },
    ]

    const containerClass = 'flex items-center justify-end gap-2'
    const textClass = 'font-inter text-sm text-neutral-800 font-medium'
    const buttonGroupClass = 'inline-flex'

    const handleButtonClick = (id: string) => {
        onViewChange(id as ViewType)
    }

    return (
        <div className={classnames(containerClass)}>
            <p className={classnames(textClass)}>{t('viewAsToggle.text')}</p>
            <div className={classnames(buttonGroupClass)}>
                <IconButtonGroup
                    buttons={buttons}
                    variant="group"
                    onChange={handleButtonClick}
                    activeId={activeView}
                />
            </div>
        </div>
    )
}
